import breakImg from '../../assets/images/editorial-break.webp';
import styles from './EditorialBreak.module.css';

const BREAK_IMG = breakImg;

export function EditorialBreak() {
  return (
    <div className={styles.wrap}>
      <img src={BREAK_IMG} alt="" aria-hidden="true" className={styles.img} />
      <div className={styles.overlay} />
      <div className={styles.content}>
        <p className={styles.quote}>
          분쟁이 발생한 그 순간—
          <br />
          오킴스가 함께합니다
        </p>
        <span className={styles.credit}>법무법인 오킴스 의료전문팀</span>
      </div>
    </div>
  );
}
